<template>
  <div :class="likeStyle">
    {{ _like_count }}
  </div>
</template>

<script>
export default {
  props: {
    id: Number,
    likeCount: Number,
    likeStyle: String,
    contentType: Number
  },
  computed: {
    getLikeCount() {
      return this.$store.getters['like/getLikeCount'];
    }
  },
  data: () => ({
    _like_count: 0
  }),
  watch: {
    getLikeCount(counts) {
      if (counts[this.contentType] != undefined &&
        counts[this.contentType][this.id] != undefined &&
        this._like_count != counts[this.contentType][this.id]
      ) {
        this._like_count = counts[this.contentType][this.id];
      }
    }
  },
  mounted() {
    this._like_count = this.likeCount ?? 0;
  },
  methods: {
  }
}
</script>
